import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const INITIALIZE_PUBSUB = createAsyncActionTypes('INITIALIZE_PUBSUB');
export const SUBSCRIPTION_UPDATE = createAsyncActionTypes('SUBSCRIPTION_UPDATE');